import React from "react";
import { useParams } from "react-router-dom";
import { doc } from "firebase/firestore";
import { useFirestore, useFirestoreDocDataOnce } from "reactfire";
import Loading from "../components/LoadingComponent";
import AppInstall from "../components/AppInstall";
import { getMobileOperatingSystem } from "../utils/get_mobile_os";
import { androidAppURL, iosAppURL } from "../config/config";

const RabbiChannelPage = () => {
  const { channelId } = useParams();
  
  const channelRef = doc(useFirestore(), "app", "rabbi_channels", "channel_names", channelId);
  const { status, data } = useFirestoreDocDataOnce(channelRef);
  
  if (status === "loading") {
    return (
      <div className="h-screen w-full flex justify-center items-center">
        <Loading />
      </div>
    );
  } else if (status === "error") {
    return <div>Something went wrong...</div>;
  }
  
  const channelName = data.name || "Unknown Channel";
  const channelBanner = data.banner || "/assets/default-banner.jpg";
  const channelDescription = data.description || "No description available.";

  return (
    <div className="container mx-auto">
      {/* App install banner */}
      <div className="mb-16 mt-0 sm:mt-4">
        <AppInstall />
      </div>

      {/* Channel Information */}
      <p className="px-4 mt-4 text-2xl font-bold md:text-center">{channelName}</p> 

      <img 
        src={channelBanner} 
        alt="Channel Banner" 
        className="mx-auto mt-4 w-full md:w-96 bg-gray-100" 
      />

      <p className="mt-4 px-4 text-lg md:text-center">{channelDescription}</p>

      <p className="mt-4 px-4 font-bold md:text-center">
      Please install the R24 app to discover our newest podcasts, publications and more!
      </p>

      {/* CTA for app installation */}
      <div className="mt-4">
        <a
          href={
            getMobileOperatingSystem() === "android" ||
            getMobileOperatingSystem() === "windows"
              ? androidAppURL
              : getMobileOperatingSystem() === "ios"
              ? iosAppURL
              : androidAppURL
          }
        >
          <img 
            src="/assets/banner-768-wide.jpg" 
            alt="Download R24 App" 
            className="w-full block sm:hidden" 
          />
          <img 
            src="/assets/banner-960-wide.jpg" 
            alt="Download R24 App" 
            className="w-full hidden sm:block md:hidden" 
          />
          <img 
            src="/assets/banner-1920-wide.jpg" 
            alt="Download R24 App" 
            className="w-full hidden md:block" 
          />
        </a>
      </div>

    </div>
  );
}

export default RabbiChannelPage;
